// Filter dimensions, using the exact keys the API puts in every `selection { dimension, values[] }`.
// `depthBand` is deliberately absent: depth bands are display-only, like the reference.
export const DIMENSIONS = [
  "lineItemId", "companyKey", "assetKey", "jobFunction", "seniority", "industry", "country"
];

export const AUDIENCE_CUTS = ["seniority", "industry", "country"];

export const SUPPORTED_SCHEMA_VERSION = 1;

// Companies are bucketed by lead count; same bands as the reference. The labels come from the payload (by index)
// so they always match the server; these are only the fallback.
export const DEPTH_BANDS = [
  { label: "1 lead", lo: 1, hi: 1 },
  { label: "2 leads", lo: 2, hi: 2 },
  { label: "3 to 4 leads", lo: 3, hi: 4 },
  { label: "5 or more", lo: 5, hi: Infinity }
];

// Job function colours. The FIRST FOUR job functions take the reference build's blue, orange, green and amber; the next
// ones take the added colours; a blank/"Other"/"Unknown" value, or any function past the end of the palette, is grey.
// Position is taken from the fixed job function order (computed once from the unfiltered leads, see adapter.js), never
// from the filtered rows, so filtering out one function does not repaint the others. The label is always shown next to
// the swatch, so colour is never the only carrier of meaning. Keep the tokens in step with _funnelfuel-dashboard.scss.
export const FN_PALETTE = [
  "var(--fn-1)", "var(--fn-2)", "var(--fn-3)", "var(--fn-4)",
  "var(--fn-5)", "var(--fn-6)", "var(--fn-7)", "var(--fn-8)", "var(--fn-9)", "var(--fn-10)", "var(--fn-11)"
];
export const FN_COLOR_OTHER = "var(--fn-other)";
